import React from 'react';
import { Card } from '../ui/Card';
import { ManipulatedFormula } from '../../services/mockData';

interface ManipulatedHistoryProps {
  formulas: ManipulatedFormula[];
  onSelectFormula: (formula: ManipulatedFormula) => void;
  onDeleteFormula: (formulaId: string) => void;
}

export const ManipulatedHistory: React.FC<ManipulatedHistoryProps> = ({
  formulas,
  onSelectFormula,
  onDeleteFormula,
}) => {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <span style={{ fontSize: '10px', padding: '2px 6px', background: '#d1fae5', color: '#065f46', borderRadius: '4px', fontWeight: 600 }}>Ativa</span>;
      case 'completed':
        return <span style={{ fontSize: '10px', padding: '2px 6px', background: '#dbeafe', color: '#1e40af', borderRadius: '4px', fontWeight: 600 }}>Concluída</span>;
      case 'cancelled':
        return <span style={{ fontSize: '10px', padding: '2px 6px', background: '#fee2e2', color: '#991b1b', borderRadius: '4px', fontWeight: 600 }}>Cancelada</span>;
      default:
        return null;
    }
  };

  if (formulas.length === 0) {
    return (
      <Card title="Histórico de Prescrições">
        <p style={{ textAlign: 'center', color: 'var(--page-text-muted)', padding: '20px' }}>
          Nenhuma prescrição encontrada.
        </p>
      </Card>
    );
  }

  return (
    <Card title="Histórico de Prescrições" subtitle={`${formulas.length} prescrição(ões) encontrada(s)`}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '500px', overflowY: 'auto' }}>
        {formulas.map((formula) => (
          <div
            key={formula.id}
            style={{
              padding: '16px',
              background: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#eff6ff';
              e.currentTarget.style.borderColor = '#0ea5e9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#f8fafc';
              e.currentTarget.style.borderColor = '#e2e8f0';
            }}
            onClick={() => onSelectFormula(formula)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '8px' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <div style={{ fontWeight: 600, fontSize: '14px' }}>{formula.formulaName}</div>
                  {getStatusBadge(formula.status)}
                </div>
                <div style={{ fontSize: '12px', color: 'var(--page-text-muted)', marginBottom: '4px' }}>
                  <div><strong>Ingredientes:</strong> {formula.ingredients.map(i => `${i.name} (${i.quantity}${i.unit})`).join(', ')}</div>
                  <div style={{ marginTop: '4px' }}><strong>Posologia:</strong> {formula.posology}</div>
                  <div style={{ marginTop: '4px' }}>
                    <strong>Quantidade:</strong> {formula.quantity} {formula.unit} | 
                    <strong> Duração:</strong> {formula.duration} dias | 
                    <strong> Validade:</strong> {formula.validity} dias
                  </div>
                  {formula.laboratory && (
                    <div style={{ marginTop: '4px' }}><strong>Laboratório:</strong> {formula.laboratory}</div>
                  )}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--page-text-muted)', marginTop: '4px' }}>
                  Prescrito em: {new Date(formula.prescribedAt).toLocaleDateString('pt-BR')} às {new Date(formula.prescribedAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm('Tem certeza que deseja cancelar esta prescrição?')) {
                    onDeleteFormula(formula.id);
                  }
                }}
                style={{
                  padding: '4px 8px',
                  background: 'var(--theme-danger-solid)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '11px',
                }}
                title="Cancelar prescrição"
              >
                ✕
              </button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

